// extracted by mini-css-extract-plugin
export default {"div-results":"SectionResults_div-results__PGZaE","results-container":"SectionResults_results-container__PoXhj","buttons-container":"SectionResults_buttons-container__Qo14v"};